import React from "react";
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';

import TabPanes from "modules/system_setup/tab";

const {Content} = Layout;

function SystemSetup() {
    return (
        <div>
            <Card>
                <PageTitle pageTitle="SYSTEM SETUP" />
                <Content>
                    <TabPanes />
                </Content>
            </Card>
        </div>
    )
}

export default SystemSetup;